import { h } from "preact";

const colorMap = {
    info: "#42a5f5",
    warning: "#ffb300",
    error: "#ef5350",
    success: "#66bb6a"
}

export function NoticeBlock(props: {
    type: "info" | "warning" | "error" | "success",
    children: string,
    style?: { [key: string]: string }
}) {
    return props.children ? <div>
        <div class={"alert " + props.type} style={{
            ...props.style
        }}>
            {props.children}
        </div>
    </div> : null;
}
